import { create } from "zustand";
import type { GoogleStatus } from "../../shared/googleAnalytics";
import { api } from "../lib/api";

export const useGoogle = create<{ status: GoogleStatus | null; error: string | null }>(() => ({ status: null, error: null }));
export async function loadGoogle(): Promise<GoogleStatus> {
  const status = await api<GoogleStatus>("/api/google/status");
  useGoogle.setState({ status, error: null });
  return status;
}
export async function googleProperties(): Promise<GoogleStatus> {
  const status = await api<GoogleStatus>("/api/google/properties", { body: {} });
  useGoogle.setState({ status, error: null });
  return status;
}
export async function selectGoogleProperty(property: string): Promise<GoogleStatus> {
  const status = await api<GoogleStatus>("/api/google/property", { body: { property } });
  useGoogle.setState({ status, error: null });
  return status;
}
export async function disconnectGoogle(): Promise<void> {
  const status = await api<GoogleStatus>("/api/google/disconnect", { body: {} });
  useGoogle.setState({ status, error: null });
}
/** Open synchronously, so the browser treats it as the click the user made. */
export async function signInGoogle(): Promise<GoogleStatus> {
  const popup = window.open("about:blank", "cb-google-signin", "width=600,height=760");
  if (!popup) throw new Error("Allow a pop-up for Context Board, then try connecting Google again.");
  try {
    const result = await api<{ authorizeUrl: string }>("/api/google/start", { body: {} });
    const origin = window.location.origin;
    return await new Promise<GoogleStatus>((resolve, reject) => {
      let finished = false;
      const finish = async () => {
        if (finished) return;
        finished = true;
        clearInterval(poll); clearTimeout(deadline);
        window.removeEventListener("message", message);
        channel?.close();
        try {
          const status = await loadGoogle();
          if (!status.connected) reject(new Error("Google sign-in did not finish. Try again and allow read-only Analytics access."));
          else resolve(status);
        } catch (e) { reject(e); }
      };
      const message = (e: MessageEvent) => {
        if (e.origin !== origin || e.source !== popup || e.data?.type !== "cb:mcp-auth" || e.data?.provider !== "google") return;
        void finish();
      };
      const channel = typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel("cb-mcp-auth");
      if (channel) channel.onmessage = (e) => { if (e.data?.provider === "google") void finish(); };
      const poll = setInterval(() => { if (popup.closed) void finish(); }, 700);
      const deadline = setTimeout(() => { popup.close(); void finish(); }, 15 * 60_000);
      window.addEventListener("message", message);
      popup.location.href = result.authorizeUrl;
    });
  } catch (e) { popup.close(); throw e; }
}
